const STORAGE_KEY = 'search_keywords';
const MAX_ITEMS = 30;

interface SearchKeywordItem {
    videoId: string;
    keyword: string;
}

interface SearchKeywordState {
    items: SearchKeywordItem[];
}

function load(): SearchKeywordState {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '') as SearchKeywordState;
    } catch {
        return { items: [] };
    }
}

function save(state: SearchKeywordState): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function storeSearchKeyword(videoId: string, keyword: string): void {
    const state = load();
    const existingIndex = state.items.findIndex((item) => item.videoId === videoId);
    if (existingIndex !== -1) {
        state.items.splice(existingIndex, 1);
    }
    state.items.push({ videoId, keyword });
    if (state.items.length > MAX_ITEMS) {
        state.items = state.items.slice(-MAX_ITEMS);
    }
    save(state);
}

export function getSearchKeyword(videoId: string): string | null {
    const state = load();

    for (let i = state.items.length - 1; i >= 0; i--) {
        if (state.items[i].videoId === videoId) {
            return state.items[i].keyword;
        }
    }

    return null;
}

export function removeSearchKeyword(videoId: string): void {
    const state = load();
    state.items = state.items.filter((item) => item.videoId !== videoId);
    save(state);
}
